import { useLocale } from 'state/intl';
import { TLocaleCode } from 'types/i18n';
import { resolvePath } from 'utils/routing/resolve-path';

export const useLocalizedPath = (path: string) => {
  const { language, region } = useLocale();
  const locale: TLocaleCode = `${language}-${region}`;
  return resolvePath(locale)(path);
};
